{
	"title": "Kommentarer",
	"statuses": {
		"inValidation": "Under validering",
		"rejected": "Avvisad",
		"assured": "Bekräftad",
		"flagged": "Flaggad",
		"resolved": "Löst"
	}
}
